// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Modal from "@insite/mobius/Modal";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState) => {
    const session = state.context.session;

    return {
        isAuthenticated: session?.isAuthenticated,
        restrictedCountry: session?.properties?.restrictedCountry,
    };
};

const mapDispatchToProps = {};

export interface MXModalStyles {
    closeButton?: ButtonPresentationProps;
}

export const mxModalStyles: MXModalStyles = {};

const styles = mxModalStyles;
const MODAL_SESSION_KEY = "showMxModal";

const MXModal = ({ isAuthenticated, restrictedCountry }: Props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const modalCloseHandler = () => {
        sessionStorage?.setItem(MODAL_SESSION_KEY, "false");
        setIsModalOpen(false);
    };

    useEffect(() => {
        const sessionShowMxModal = sessionStorage?.getItem(MODAL_SESSION_KEY);
        if (!sessionShowMxModal && restrictedCountry) {
            setIsModalOpen(true);
        }
    }, [restrictedCountry]);

    if (isAuthenticated) {
        return null;
    }

    return (
        <Modal
            headline={siteMessage(`${restrictedCountry}_Custom_Modal_Headline`)}
            isOpen={isModalOpen}
            handleClose={modalCloseHandler}
        >
            <StyledWrapper>{siteMessage(`${restrictedCountry}_Custom_Modal_Body_Msg`)}</StyledWrapper>

            <StyledWrapper className="modal-actions">
                <Button onClick={modalCloseHandler} {...styles.closeButton}>
                    {siteMessage(`${restrictedCountry}_Custom_Modal_Close_Button`)}
                </Button>
            </StyledWrapper>
        </Modal>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MXModal);
